import React from "react";
import { AnimatePresence, motion } from 'framer-motion';
import { StyleUtils }   from '../utils';
import '../css/default.css';
import '../css/salient.css';
import '../css/onboarding.css';
import '../css/introSlides.css';

import screen1 from '../images/screen1.png';
import screen2 from '../images/screen2.png';
import screen3 from '../images/screen3.png';

const SLIDE_MOTION = {
  initial: (direction) => ({ opacity: 0, x: direction < 0 ? -28 : 28 }),
  animate: { opacity: 1, x: 0 },
  exit:    (direction) => ({ opacity: 0, x: direction < 0 ? 28 : -28 }),
};

export default class IntroSlides extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_slide_index: 0,
      slide_direction: 1,
    };
  }

  componentDidMount = () => {

  }

  go_to_slide = (new_index) => {
    let curr_index = this.state.active_slide_index;
    if (new_index === curr_index) {
      return;
    }
    this.setState({ active_slide_index: new_index, slide_direction: new_index > curr_index ? 1 : -1 });
  }

  render_dots = () => {
    let slides = this.get_slides();

    return <div className='intro-dots'>
      { slides.map((slide, i) => {
          let is_active = i === this.state.active_slide_index;
          return <div key={ i }
                      className={ 'intro-dot universal-button' + (is_active ? ' is-active' : '') }
                      onClick={ () => { this.go_to_slide(i); } } />;
        }) }
    </div>
  }

  render_header = () => {
    let logo_url = this.props.partner && this.props.partner.logo_url ? this.props.partner.logo_url : '';

    return <div className='onb-header'>
      { logo_url ? <img className='onb-logo' src={ logo_url } alt='' /> : null }
      <div className='intro-skip sln-pressable'
           onClick={ () => {
             if (this.props.button_action) {
               this.props.button_action();
             }
           }}>
        Skip
      </div>
    </div>
  }

  render_slide_body = (slide) => {
    let title    = slide.title    || slide.message || '';
    let subtitle = slide.subtitle || (slide.title ? slide.message : '') || '';

    return <motion.div key={ this.state.active_slide_index }
                       className='intro-slide'
                       custom={ this.state.slide_direction }
                       variants={ SLIDE_MOTION }
                       initial='initial'
                       animate='animate'
                       exit='exit'
                       transition={{ duration: 0.22, ease: 'easeOut' }}>
      <div className='intro-panel'>
        { slide.image_url ? <img src={ slide.image_url } alt='' /> : null }
      </div>
      <div className='intro-copy'>
        <span className='onb-title'>{ title }</span>
        { subtitle ? <span className='onb-subtitle'>{ subtitle }</span> : null }
      </div>
    </motion.div>
  }

  render_slides = () => {
    let slides        = this.get_slides();
    let curr_index    = this.state.active_slide_index;
    let last_index    = slides.length - 1;
    let current_slide = slides && slides[curr_index] ? slides[curr_index] : {};
    let is_last       = curr_index === last_index;
    let button_title  = is_last ? 'Get Started' : 'Next';
    let palette       = StyleUtils.get_intro_palette();

    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
      '--onb-panel':      palette.panel,
      '--onb-btn-glow':   palette.btn_glow,
    };

    return <div className='onb-root' style={ root_style }>
      <div className='onb-card'>
        { this.render_header() }

        <AnimatePresence mode='wait' initial={ false } custom={ this.state.slide_direction }>
          { this.render_slide_body(current_slide) }
        </AnimatePresence>

        { this.render_dots() }

        <div className='onb-btn sln-pressable'
             onClick={ () => {
               if (is_last) {
                 if (this.props.button_action) {
                   this.props.button_action();
                 }
                 return;
               }
               this.go_to_slide(curr_index + 1);
             }}>
          <span>{ button_title }</span>
          <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
            <path d='M9 6l6 6-6 6' />
          </svg>
        </div>
      </div>
    </div>
  }

  render() {
    return this.render_slides();
  }

  get_slides = () => {
    let slides = [
      { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png', message: "Raising our fur-fam is hard!! We’re here 24/7." },
      { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
      { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
    ];

    let partner        = this.props.partner;
    let customizations = partner && partner.style_customizations ? partner.style_customizations : {};

    let slide_1 = { image_url: customizations.slide_1_url, message: customizations.slide_1_text, title: customizations.slide_1_title, subtitle: customizations.slide_1_subtitle };
    let slide_2 = { image_url: customizations.slide_2_url, message: customizations.slide_2_text, title: customizations.slide_2_title, subtitle: customizations.slide_2_subtitle };
    let slide_3 = { image_url: customizations.slide_3_url, message: customizations.slide_3_text, title: customizations.slide_3_title, subtitle: customizations.slide_3_subtitle };

    // let slide_1        = { image_url: screen1, message: customizations.slide_1_text };
    // let slide_2        = { image_url: screen2, message: customizations.slide_2_text };
    // let slide_3        = { image_url: screen3, message: customizations.slide_3_text };

    if (slide_1.image_url && slide_1.message && slides[0]) {
      slides[0] = slide_1;
    }

    if (slide_2.image_url && slide_2.message && slides[1]) {
      slides[1] = slide_2;
    }

    if (slide_3.image_url && slide_3.message && slides[2]) {
      slides[2] = slide_3;
    }

    return slides;
  }

  get_slides_2 = () => {
    let slides  = [];
    let partner = this.props.partner_name;

    switch (partner) {
      case 'teletails':
        let teletails_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',     message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...teletails_slides ]
        break;
      case 'hills':
        let hills_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Hills3.jpg',     message: "24/7 free online nutritional care, brought to you by Hill’s Pet Nutrition." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/HillsLogo2-1.png', message: 'Convenient, trusted, on-demand vet pro visits available 24/7 from home.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/HillsLogo3-1.png', message: 'Care coordinated with your local clinic, but accessible from home.' },
        ];
        slides = [ ...hills_slides ]
        break;
      case 'drmarty':
        let drmarty_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/DrM2.png',  message: "Text: 24/7 online pet care, brought to you by Dr. Marty Pets." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Our pets are family. With all the ways our dogs and cats love us, it’s natural we provide them with the best food & care.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'We have you covered with convenient, trusted, on-demand vet pro visits available from home.' },
        ];
        slides = [ ...drmarty_slides ]
        break;
      case 'snugglepuppy':
        let snugglepuppy_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising a puppy is hard! We’re here to help, 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...snugglepuppy_slides ]
        break;
      case 'darwins':
        let darwins_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/1%20(5).png', message: "We're here 24/7 to support your pet's health journey." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2%20(5).png', message: 'Live chats and 1x1 video sessions with caring veterinary professionals.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3%20(3).png', message: 'Nutrition, health, behavior, and more. Talk to an expert immediately.' },
        ];
        slides = [ ...darwins_slides ]
        break;
      case 'thedogstop':
        let thedogstop_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...thedogstop_slides ]
        break;
      case 'zestypaws':
        let zestypaws_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...zestypaws_slides ]
        break;
      case 'wag':
        let wag_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...wag_slides ]
        break;
      case 'fullmoon':
        let fullmoon_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/1.png', message: "Members access 24/7 online pet care, brought to you by Full Moon." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2.png', message: 'Video and chat sessions with trusted vet pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3.png', message: 'Become a Full Moon member today!' },
        ];
        slides = [ ...fullmoon_slides ]
        break;
      case 'fable':
        let fable_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(21).png',     message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...fable_slides ]
        break;
      case 'getjoy':
        let getjoy_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...getjoy_slides ]
        break;
      case 'wagmo':
        let wagmo_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/wagmo-slider-1.png', message: "Convenient, Trusted, & On-Demand. Virtual Pet Care." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/wagmo-slider-2.png', message: 'Real professionals...not that random person from the dog park.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/wagmo-slider-3.png', message: 'Quit using “Dr. Google”. Connect with someone you can trust.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/wagmo-slider-4.png', message: 'Sessions are available through chat or video - whatever works best  for you!' },
        ];
        slides = [ ...wagmo_slides ]
        break;
      case 'teletailsprod':
        let teletailsprod_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/1-1.png', message: "Does your dog jump, bark, or pull? We can help." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2-1.png', message: 'Private online training with licensed training pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-1.png', message: 'Fully customized sessions are 100% focused on your needs.' },
        ];
        slides = [ ...teletailsprod_slides ]
        break;
      case 'westernshore':
        let westernshore_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT1%20(2).png', message: "Does your dog jump, bark, or pull? Diggs can help." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2-1.png', message: 'Private online training with licensed training pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-1.png', message: 'Fully customized sessions are 100% focused on your needs.' },
        ];
        slides = [ ...westernshore_slides ]
        break;
      case 'diggs':
        let diggs_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/DIGGS-Intro.png', message: "Does your dog jump, bark, or pull? We can help." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2-1.png', message: 'Private online training with licensed training pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-1.png', message: 'Fully customized sessions are 100% focused on your needs.' },
        ];
        slides = [ ...diggs_slides ]
        break;
      case 'dodovet':
        let dodovet_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/TeleTails%20Logos%20(1).png', message: "Does your dog jump, bark, or pull? We can help." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2-1.png', message: 'Private online training with licensed training pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-1.png', message: 'Fully customized sessions are 100% focused on your needs.' },
        ];
        slides = [ ...dodovet_slides ]
        break;
      case 'petstable':
        let petstable_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT1.png', message: "Raising our fur-fam is hard! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-2.png', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT3.png', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...petstable_slides ]
        break;
      case 'ctv':
        let ctv_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "We are your pet’s after-hours triage care!" },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Save the time and stress of an urgent care visit. Chat with us first!' },
        ];
        slides = [ ...ctv_slides ]
        break;
      case 'pupford':
        let pupford_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard!! Pupford is here for you 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...pupford_slides ]
        break;
      case 'upc':
        let upc_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/6.png',         message: "United Pet Care members have access to 24/7 online pet care."        },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT3-1.png',     message: 'Chat, live video, or phone sessions with our caring pet care pros.'  },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT1%20(1).png', message: 'Health, wellness, behavior and and more! Talk to a pro immediately.' },
        ];
        slides = [ ...upc_slides ]
        break;
      case 'upctraining':
        let upc_training_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/6.png',         message: "Does your dog jump, bark, or pull? Our dog trainers can help." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT3-1.png',     message: 'Private online dog training with licensed training pros.'      },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT1%20(1).png', message: 'Fully customized sessions are 100% focused on your needs.'     },
        ];
        slides = [ ...upc_training_slides ]
        break;
      case 'embark':
        let embark_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/1-2.png', message: "Embark Health+ members have access to 24/7 online pet care."         },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/2-2.png', message: 'Chat, live video, or phone sessions with our caring pet care pros.'  },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/3-3.png', message: 'Health, wellness, behavior and and more! Talk to a pro immediately.' },
        ];
        slides = [ ...embark_slides ]
        break;
      case 'supportpets':
        let supportpets_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/PT1%20(3).png', message: "Welcome to Support Pets televet service!"         },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg', message: 'We’re here for you 24/7, 365 days a year,'  },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg', message: 'Through 1x1 video sessions and chats with our vet pros.' },
        ];
        slides = [ ...supportpets_slides ]
        break;
      default:
        let default_slides = [
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/Untitled%20design%20(5).png',  message: "Raising our fur-fam is hard!! We’re here 24/7." },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-1.jpg',                    message: 'Live chats and 1x1 video sessions with caring veterinary pros.' },
          { image_url: 'https://4728109.fs1.hubspotusercontent-na1.net/hubfs/4728109/New-2.jpg',                    message: 'Nutrition, health, behavior, and more! Talk to a pro immediately.' },
        ];
        slides = [ ...default_slides ]
    }

    return slides;
  }
}
